// @flow
// TODO: Modify this when OmniNav is external
import React, { createContext } from 'react';
// $FlowFixMe
const { Provider, Consumer } = createContext({ reveal: true });

export const NavRevealConsumer = Consumer;

type Props = {
  children: any
};

type State = {
  reveal: boolean
};

export class Navigation extends React.Component<Props, State> {
  prevScroll: number;

  state = {
    reveal: true
  };

  handleScroll = () => {
    const { reveal } = this.state;
    const scrollDown = this.prevScroll < window.pageYOffset;
    this.prevScroll = window.pageYOffset;
    if (scrollDown) return reveal && window.pageYOffset >= 240 && this.setState({ reveal: false });
    return !reveal && window.pageYOffset <= 240 && this.setState({ reveal: true });
  };

  setReveal = () => {
    !this.state.reveal && this.setState({ reveal: true });
  };

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
    this.prevScroll = 0;
  }

  render() {
    const { reveal } = this.state;
    return <Provider value={{ reveal, setReveal: this.setReveal }}>{this.props.children}</Provider>;
  }
}
